import { render, staticRenderFns } from "./new-post-detail.vue?vue&type=template&id=12a01d42&scoped=true&"
import script from "./new-post-detail.vue?vue&type=script&lang=js&"
export * from "./new-post-detail.vue?vue&type=script&lang=js&"
import style0 from "./new-post-detail.vue?vue&type=style&index=0&id=12a01d42&lang=scss&scoped=true&"
import style1 from "./new-post-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a01d42",
  null
  
)

export default component.exports